import type { TabData } from "rc-dock";
import { parseTabId } from "@/contexts/tabsContext";
import { TabTitle } from "@/chat2/components/chatlayout/TabTitle";
import { FilePreviewTab } from "./FilePreviewTab";

export const FilePreviewTabRenderer = (id: string): TabData => {
  const { entityId } = parseTabId(id);
  const fileId = entityId ?? "";
  return {
    id,
    title: <TabTitle id={id} />,
    content: <FilePreviewTab fileId={fileId} tabId={id} />,
  };
};
